import moment from 'moment';
import { VALID_DATE_FORMATS } from '../constants';

const RequiredCovieDirectLinkParams = [
  'firstName',
  'lastName',
  'leaseStart',
  'leaseEnd',
  'email',
  'buildingId',
] as const;

function validateRequiredCovieDirectLinkParams(
  searchParams: Record<string, string>,
): boolean {
  return RequiredCovieDirectLinkParams.every(
    (key) =>
      searchParams.hasOwnProperty(key) &&
      searchParams[key] !== undefined &&
      searchParams[key] !== '',
  );
}

function validateEmail(email: string) {
  const validateEmail = document.createElement('input');

  validateEmail.type = 'email';
  validateEmail.required = true;
  validateEmail.value = email;

  return validateEmail.checkValidity();
}

const validateBuildingId = (buildingId: string) => {
  const numericRegex = /^\d+$/;
  return numericRegex.test(buildingId);
};

const validateBuildingUnit = (buildingUnitString: string) => {
  if (!buildingUnitString) {
    return true;
  }
  const alphaNumericRegex = /^(?:\d+[A-Za-z]?|[A-Za-z]\d*)$/;
  return alphaNumericRegex.test(buildingUnitString);
};

const validateDateFormat = (dateString: string) => {
  return moment(dateString, VALID_DATE_FORMATS, true).isValid();
};

const validateValidDates = (leaseStart: string, leaseEnd: string) => {
  const start = moment(leaseStart, VALID_DATE_FORMATS);
  const end = moment(leaseEnd, VALID_DATE_FORMATS);
  const today = moment().startOf('day');

  return start.isBefore(end) && end.isAfter(today);
};

const validateName = (nameString: string) => {
  const nameFieldRegex = /^[a-zA-Z_ '\\\`\\-]{1,50}$/;
  return nameFieldRegex.test(nameString);
};

export function validateCovieDirectLinkParams(
  searchParams: Record<string, string>,
): boolean {
  if (!searchParams) {
    return false;
  }

  const areRequiredSearchParamsProvided =
    validateRequiredCovieDirectLinkParams(searchParams);

  if (!areRequiredSearchParamsProvided) {
    return false;
  }

  const isValidSearchParams =
    validateEmail(searchParams.email) &&
    validateBuildingId(searchParams.buildingId) &&
    validateDateFormat(searchParams.leaseStart) &&
    validateDateFormat(searchParams.leaseEnd) &&
    validateName(searchParams.firstName) &&
    validateName(searchParams.lastName) &&
    validateBuildingUnit(searchParams.buildingUnit) &&
    validateValidDates(searchParams.leaseStart, searchParams.leaseEnd);

  return isValidSearchParams;
}
